import api from "./api";

// Base API URL and endpoints configuration
const API_BASE = "api/admin";
const ENDPOINTS = {
    check: `${API_BASE}`,
    dashboard: `${API_BASE}/dashboard`,
    trucks: `${API_BASE}/car`,
    reception: `${API_BASE}/reception`,
    users: `${API_BASE}/user`,
    driver: `${API_BASE}/driver`,
    requests: `${API_BASE}/req`,
    bills: `${API_BASE}/bill`,
    adjustment: `${API_BASE}/adjustment`,
    settings: `${API_BASE}/setting`,
    notification: `${API_BASE}/notification/get-unanswer-req`,
    adminSetting: `${API_BASE}/admin-setting`,
    publicNotice: `${API_BASE}/notice`,
    shippingBills: `${API_BASE}/way-bills`,
    backup: `${API_BASE}/backup`,
};

// Helper Functions
const uploadFile = (url, formData) => {
    return api.post(url, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};

const createCheckEndpoint = (type) => (value) =>
    api.post(`${ENDPOINTS.check}/check-${type}`, { [type]: value });

// CSRF Token
export const csrfCookies = () => api.get("sanctum/csrf-cookie");

// Verification APIs
export const verifyNationalCodeApi = createCheckEndpoint("nationalcode");
export const verifyPhoneNumberApi = createCheckEndpoint("phone");
export const verifyPlateApi = createCheckEndpoint("plate");

// Dashboard APIs
export const allDataCount = () => api.get(ENDPOINTS.dashboard);
export const adjustmentDirectoriesApi = () =>
    api.get(`${ENDPOINTS.dashboard}/get-adjustment-directories`);
export const billsDirectoriesApi = () =>
    api.get(`${ENDPOINTS.dashboard}/get-bill-directories`);

// Trucks APIs
export const allTrucks = () => api.get(ENDPOINTS.trucks);
export const editCarsApi = (carID) =>
    api.post(`${ENDPOINTS.trucks}/edit`, { carID });

export const changeCarActivationApi = (carID, isActive) =>
    api.post(`${API_BASE}/active-car`, { carID, isActive });

export const updateCarsApi = (
    carID,
    smartcode,
    tag,
    tagSerial,
    tag_serial_num,
    tankertype,
    factory,
    chassiscode,
    enginecode,
    vincode,
    year
) =>
    api.post(`${ENDPOINTS.trucks}/update`, {
        carID,
        smartcode,
        tag,
        tagSerial,
        tag_serial_num,
        tankertype,
        factory,
        chassiscode,
        enginecode,
        vincode,
        year,
    });

// Reception APIs
export const createTruck = (
    name,
    family,
    phone,
    nationalcode,
    smartcode,
    tag,
    tag_serial_num,
    tankertype,
    factory,
    chassiscode,
    enginecode,
    vincode,
    year
) =>
    api.post(ENDPOINTS.reception, {
        name,
        family,
        phone,
        nationalcode,
        smartcode,
        tag,
        tag_serial_num,
        tankertype,
        factory,
        chassiscode,
        enginecode,
        vincode,
        year,
    });

// Users APIs
export const allUsers = () => api.get(ENDPOINTS.users);
export const editUserApi = (userID) =>
    api.post(`${ENDPOINTS.users}/edit`, { userID });

export const addCarToDriverApi = (
    userID,
    smartcode,
    tag,
    tag_serial_num,
    tankertype,
    factory,
    chassiscode,
    enginecode,
    vincode,
    year
) =>
    api.post(`${ENDPOINTS.users}/add-car-to-user`, {
        userID,
        smartcode,
        tag,
        tag_serial_num,
        tankertype,
        factory,
        chassiscode,
        enginecode,
        vincode,
        year,
    });

export const updateUserApi = (userID, name, family, nationalcode, phone) =>
    api.post(`${ENDPOINTS.users}/update`, {
        userID,
        name,
        family,
        nationalcode,
        phone,
    });

export const deleteCarFromUserApi = (carId) =>
    api.post(`${ENDPOINTS.users}/delete-car`, {
        carId,
    });

export const changeUserActivationApi = (userID, isActive) =>
    api.post(`${API_BASE}/active-user`, { userID, isActive });

// Drivers APIs
export const allDriverApi = () => api.get(ENDPOINTS.driver);

// Requests APIs
export const allRequests = () => api.get(ENDPOINTS.requests);
export const editRequestsApi = (reqID, status) =>
    api.post(`${ENDPOINTS.requests}/answer`, { reqID, status });
export const updateRequestsApi = (reqID, answer, status) =>
    api.post(`${ENDPOINTS.requests}/update`, { reqID, answer, status });

// Bills APIs
export const uploadPdfApi = (formData) =>
    uploadFile(`${ENDPOINTS.bills}/upload-pdf`, formData);
export const uploadZipApi = (formData) =>
    uploadFile(`${ENDPOINTS.bills}/upload-zip`, formData);
export const synchronizationSummaryApi = (month) =>
    api.post(`${ENDPOINTS.bills}/sync-zip`, { month });
export const synchronizationBillsApi = (month) =>
    api.post(`${ENDPOINTS.bills}/sync-pdf`, { month });
export const findSameTagApi = (month) =>
    api.post(`${ENDPOINTS.bills}/same-pluck`, { month });
export const fixSameTagApi = (formData, month) =>
    api.post(`${ENDPOINTS.bills}/save-same-pluck`, { formData, month: month });
export const getBillYearApi = () => api.get(`${ENDPOINTS.bills}/get-years`);
export const getBillMonthApi = (year) =>
    api.post(`${ENDPOINTS.bills}/get-months`, { year });
export const getAllBillApi = (year, month) =>
    api.post(`${ENDPOINTS.bills}/get-month-bills`, { year, month });
export const runPythonApi = (filePath, month) =>
    api.post(`${ENDPOINTS.bills}/run-python-script`, { filePath, month });
export const downloadAllBillApi = (year, month) =>
    api.post(`${ENDPOINTS.bills}/download-month-files`, { year, month });
export const downloadAllBillExcelsRequestApi = (year, month) =>
    api.post(`${ENDPOINTS.bills}/download-excel-request`, { year, month });
export const downloadAllBillExcelsApi = (year, month) =>
    api.post(`${ENDPOINTS.bills}/download-summary-excel`, { year, month });
export const checkBillFolder = (month) =>
    api.post(`${ENDPOINTS.bills}/check-bill-folder`, { month });

// Adjustment APIs
export const getAdjustmentYearApi = () =>
    api.get(`${ENDPOINTS.adjustment}/get-years`);
export const getAdjustmentMonthApi = (year) =>
    api.post(`${ENDPOINTS.adjustment}/get-months`, { year });
export const getAllAdjustmentApi = (year, month) =>
    api.post(`${ENDPOINTS.adjustment}/get-month-adjustments`, { year, month });
export const uploadAdjustmentZipApi = (formData) =>
    uploadFile(`${ENDPOINTS.adjustment}/upload-zip`, formData);
export const synchronizationAdjustmentSummaryApi = (month) =>
    api.post(`${ENDPOINTS.adjustment}/sync-zip`, { month });
export const uploadAdjustmentPdfApi = (formData) =>
    uploadFile(`${ENDPOINTS.adjustment}/upload-pdf`, formData);
export const synchronizationAdjustmentApi = (month) =>
    api.post(`${ENDPOINTS.adjustment}/sync-pdf`, { month });
export const runAdjustmentPythonApi = (filePath, month) =>
    api.post(`${ENDPOINTS.adjustment}/run-python-script`, { filePath, month });
export const findAdjSameTagApi = (month) =>
    api.post(`${ENDPOINTS.adjustment}/same-pluck`, { month });
export const fixAdjSameTagApi = (formData, month) =>
    api.post(`${ENDPOINTS.adjustment}/save-same-pluck`, {
        formData,
        month: month,
    });
export const downloadAllAdjApi = (year, month) =>
    api.post(`${ENDPOINTS.adjustment}/download-month-files`, { year, month });
export const downloadAllAdjExcelsRequestApi = (year, month) =>
    api.post(`${ENDPOINTS.adjustment}/download-excel-request`, { year, month });
export const downloadAllAdjExcelsApi = (year, month) =>
    api.post(`${ENDPOINTS.adjustment}/download-summary-excel`, { year, month });
export const checkAdjustmentsFolder = (month) =>
    api.post(`${ENDPOINTS.adjustment}/check-adjustments-folder`, {month});

// Settings APIs
export const uploadLogoApi = (formData) =>
    uploadFile(`${ENDPOINTS.settings}/upload-logo`, formData);
export const getCompanyInfoApi = () => api.get(ENDPOINTS.settings);
export const updateCompanyInfo = (basicSiteInfos) =>
    api.post(`${ENDPOINTS.settings}/update`, { basicSiteInfos });

// Notification APIs
export const getUnansweredRequestsApi = () => api.get(ENDPOINTS.notification);

// Admin Setting APIs
export const getAdminInfoApi = () =>
    api.get(`${ENDPOINTS.adminSetting}/get-admin`);
export const storeAdminInfoApi = (name, family, phone, nationalcode) =>
    api.post(`${ENDPOINTS.adminSetting}/store-admin`, {
        name,
        family,
        phone,
        nationalcode,
    });
export const editAdminInfoApi = (userID) =>
    api.post(`${ENDPOINTS.adminSetting}/edit-admin`, { userID });
export const updateAdminApi = (userID, name, family, phone, nationalcode) =>
    api.post(`${ENDPOINTS.adminSetting}/update-admin`, {
        userID,
        name,
        family,
        phone,
        nationalcode,
    });
export const deleteAdminApi = (userID) =>
    api.post(`${ENDPOINTS.adminSetting}/delete-admin`, { userID });
export const changeAdminActivationApi = (userID, isActive) =>
    api.post(`${API_BASE}/active-admin`, { userID, isActive });

// Public Notice APIs
export const createNoticeApi = (title, text) =>
    api.post(`${ENDPOINTS.publicNotice}/store-notice`, { title, text });
export const getAllNoticeApi = () =>
    api.get(`${ENDPOINTS.publicNotice}/get-notice`);
export const getActiveNoticeApi = () =>
    api.get(`${ENDPOINTS.publicNotice}/get-notice-active`);
export const changeNoticeActivationApi = (noticeID, isActive) =>
    api.post(`${API_BASE}/active-notice`, { noticeID, isActive });
export const deleteNoticeApi = (noticeID) =>
    api.post(`${ENDPOINTS.publicNotice}/delete-notice`, { noticeID });
export const editNoticeApi = (noticeID) =>
    api.post(`${ENDPOINTS.publicNotice}/edit-notice`, { noticeID });
export const updateNoticeApi = (noticeID, title, text) =>
    api.post(`${ENDPOINTS.publicNotice}/update-notice`, {
        noticeID,
        title,
        text,
    });

// Upload Users Excel
export const uploadUsersExcelApi = (formData) =>
    uploadFile(`${ENDPOINTS.reception}/upload-excel`, formData);

// Shipping Bills APIs
export const sendShippingBillApi = (tankerTag, tankerTagSerial) =>
    api.post(`${ENDPOINTS.shippingBills}/scan`, {
        tankerTag: tankerTag,
        tankerTagSerial: tankerTagSerial,
    });
export const storeShippingBillApi = (billData) =>
    api.post(`${ENDPOINTS.shippingBills}/store`, { billData });
export const filterShippingBillsApi = (activeFilters) =>
    api.post(`${ENDPOINTS.shippingBills}/get-all`, { activeFilters });

// Backups Data APIs
export const backupUserDataApi = (data) =>
    api.post(`${ENDPOINTS.backup}/get-total-list`, { data });

export const backupFilesApi = (data) =>
    api.post(`${ENDPOINTS.backup}/get-files`, { data });
export const backupDataBaseApi = (data) =>
    api.post(`${ENDPOINTS.backup}/get-db`, { data });
